import {decorate, observable, action, computed} from 'mobx';

class ModalStore {

    cls = 'modal display-none'
    agreementText = ''
    proceedAction = ''
    title = ''


    openModal = (text, callback, title, width = 570) => {
        this.cls = 'modal display-block'
        this.agreementText = text;
        this.proceedAction = callback;
        this.title = title
        $(".modal-main").css('width', `${width}px`)
        if (window.screen.width < 770) {
            $(".modal-main").css('width', '300px')
        }
    }

}

decorate(ModalStore, {
    cls: observable,
    agreementText: observable
})
const store = new ModalStore();
export default store;